import { render, staticRenderFns } from "./BiddingTableEditor.vue?vue&type=template&id=a81dc648&scoped=true&"
import script from "./BiddingTableEditor.vue?vue&type=script&lang=js&"
export * from "./BiddingTableEditor.vue?vue&type=script&lang=js&"
import style0 from "./BiddingTableEditor.vue?vue&type=style&index=0&id=a81dc648&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81dc648",
  null
  
)

export default component.exports